// import React from "react";
// import CardsBorder from "../../../../../components/Cards/CardsBorder";
// import { DialogBox } from "../../../../../components/Elements/DialogBox";
// import { CloseCircleOutlined, } from "@ant-design/icons";
// const LimitExceedPopup = ({ onOpen, onClose, selectedRole }) => {
//   return (
//     <DialogBox open={onOpen} onCancel={onClose} width="50%" maxWidth="500px" showClose>
//       {/* <div className="mt-6 text-center">
//         <CardsBorder>
//           <div className="py-4 text-center">
//             <p className="text-sm">
//               You are trying to assign this form to a {selectedRole} but you do
//               not have any remaining licenses for this role.
//             </p>
//             <p className="text-xl mt-14">
//               Please purchase additional {selectedRole} licenses to proceed.
//             </p>
//           </div>
//         </CardsBorder>
//       </div> */}
//       <div className="">
//         {/* <CardsBorder> */}
//         {/* <div className="py-4 text-center">
//               <p className="text-sm">
//                 you are assigning this form to a {selectedRole} This Action will
//                 consume 1 license from your available {selectedRole} licenses.
//               </p>
//               <p className="text-xl">Do you want to proceed?</p>

//               <div className="flex justify-center gap-4 py-6">
//                 <CustomButton
//                   buttonType="#06513D"
//                   variant="cancel"
//                   buttonText="Cancel"
//                   className="text-sm px-6 py-2 rounded-lg"
//                   onClick={onClose}
//                 />
//                 <CustomButton
//                   buttonType="#06513D"
//                   variant="Yes, Proceed"
//                   buttonText="Save"
//                   className=" text-sm px-6 py-2 rounded-lg"
//                   onClick={handleProceed}
//                 />
//               </div>
//             </div> */}
//         <div className="flex flex-col items-center text-center -mt-6 -mx-6 -mb-6">
//           {/* Green Header */}
//           <div className="w-full bg-[#D32F2F] px-6 py-3 text-white text-center font-normal text-lg">
//             You are trying to assign this form to a {selectedRole} but you do
//             not have any remaining licenses for this role.
//           </div>

//           {/* Modal Body */}
//           <div className="w-full bg-white  py-4">
//             <div className="bg-[#D32F2F] p-3 rounded-full mx-auto w-fit mb-6">
//               <CloseCircleOutlined style={{ fontSize: 32, color: "#ffffff" }} />
//             </div>
//             <p className="text-[#06513D] text-base mb-6 font-medium">
//               Please purchase additional {selectedRole} licenses to proceed.
//             </p>
//           </div>
//         </div>

//         {/* </CardsBorder> */}
//       </div>
//     </DialogBox>
//   );
// };

// export default LimitExceedPopup;
// LimitExceedPopup.jsx
import React from "react";
//import { DialogBox } from "../../../../../components/Elements/DialogBox";
import { CloseCircleOutlined } from "@ant-design/icons";
import { DialogBoxApply } from "../../../../../components/Elements/DialogBox/DialogBoxApply";
const LimitExceedPopup = ({ onOpen, onClose, selectedRole }) => {
  return (
    <DialogBoxApply
      open={onOpen}
      onCancel={onClose}
      width="50%"
      maxWidth="500px"
    >
      <div className="flex flex-col items-center text-center -mt-6 -mx-6 -mb-6">
        {/* Red Header */}
        <div className="w-full bg-[#D32F2F] px-0 py-3 text-white text-center font-normal text-lg">
          You are trying to assign this form to a {selectedRole} but you do not
          have any remaining licenses for this role.
        </div>

        {/* Modal Body */}
        <div className="w-full bg-white py-4">
          <div className="bg-[#D32F2F] p-2 rounded-full mx-auto w-fit mb-4">
            <CloseCircleOutlined style={{ fontSize: 30, color: "#ffffff" }} />
          </div>
          <p className="text-[#06513D] text-base mb-6 font-medium">
            Please purchase additional {selectedRole} licenses to proceed.
          </p>
        </div>
      </div>
    </DialogBoxApply>
  );
};

export default LimitExceedPopup;
